RivalIQ.apps.Admin.apps.Account.module('views', function (views, App, Backbone, Marionette, $, _, async) {

    'use strict';

    views.Actions = Marionette.ItemView.extend({
        template: '#adminAccountActionsTemplate',

        ui: {
            setPasswordBtn: '.x-set-password',
            passwordInput: '#newPasswordInput',
            accountDelete: '.x-account-delete',
            accountStatusBtn: '.x-account-status',
            socialSummaryBtn: '.x-social-summary',
            landscape: 'select[name=landscape]',
            resyncFacebookPresences: '.x-resync-facebook',
            resyncLinkedInPresences: '.x-resync-linkedin',
            syncSalesforce: '.x-sync-salesforce'
        },

        events: {
            'click @ui.setPasswordBtn': 'setPassword',
            'click @ui.accountStatusBtn': 'setAccountStatus',
            'click @ui.socialSummaryBtn': 'sendSocialSummary',
            'click @ui.accountDelete': 'delete',
            'click @ui.resyncFacebookPresences': 'onResyncFacebookPresences',
            'click @ui.resyncLinkedInPresences': 'onResyncLinkedInPresences',
            'click @ui.syncSalesforce': 'syncSalesforce'
        },

        templateHelpers: function () {
            const me = this;

            return {
                inviteLink: me.model.get('inviteLink'),
                landscapes: me.model.get('landscapes')
            };
        },

        landscapeDisplayString: function (landscape) {
            return `${landscape.id} [${landscape.name}]`;
        },

        onRender: function () {
            const me = this;

            _.each(me.model.get('landscapes'), function (landscape, index) {
                me.ui.landscape.append(`<option value=${index}>${me.landscapeDisplayString(landscape)}</option>`);
            });
        },

        _resyncAdminPresences: function (channel) {
            const me = this;

            const channelName = channel === 'tiktok' ? 'TikTok' : _.upperFirst(channel);
            const accountId = me.model.get('account_id');
            $.get(`/admin/resync${channelName}AdminPresences/${accountId}`)
                .then(function () {
                    RivalIQ.execute('alert:info', `${channelName} Admin Presences Updated.`);
                })
                .fail(function (error) {
                    RivalIQ.execute('alert:error', error);
                });
        },

        onResyncFacebookPresences: function () {
            const me = this;
            me._resyncAdminPresences('facebook');
        },

        onResyncLinkedInPresences: function () {
            const me = this;
            me._resyncAdminPresences('linkedIn');
        },

        syncSalesforce: async function () {
            const me = this;
            const accountId = me.model.get('account_id');
            $.post(`/admin/api/accounts/${accountId}/salesforce`)
                .then(function () {
                    RivalIQ.execute('alert:info', 'Sync account complete.');
                })
                .fail(function (error) {
                    RivalIQ.execute(
                        'alert:warning', `public/apps/admin/account/views/actions.js
                         - error with post to /admin/api/accounts/${accountId}/salesforce:`
                    );
                    RivalIQ.execute('alert:error', error);
                });
        },

        setAccountStatus: function (e) {
            const me = this;
            const statusType = Number($(e.target).data('type'));

            me.ui.accountStatusBtn.button('loading');

            const deferred = async.callbackToDeferred(function (error) {
                me.ui.accountStatusBtn.button('reset');

                if (error) {
                    return RivalIQ.execute('alert:error', error);
                }

                RivalIQ.execute('alert:info', 'Account status set');
            });

            const account = me.model.getAccount();
            account.save({
                account_status_id: statusType
            }).done(deferred.resolve).fail(deferred.reject);
        },

        sendSocialSummary: function () {
            const me = this;
            me.ui.socialSummaryBtn.button('loading');

            const deferred = async.callbackToDeferred(function (error) {
                me.ui.socialSummaryBtn.button('reset');

                if (error) {
                    return RivalIQ.execute('alert:error', error);
                }

                RivalIQ.execute('alert:info', `Social Summary email requested for ${me.model.get('email')}`);
            });

            const account = me.model.getAccount();
            account.sendDashboardEmail(2).done(deferred.resolve).fail(deferred.reject);
        },

        setPassword: function () {
            const me = this;
            const password = $.trim(me.ui.passwordInput.val());

            if (!password.length) {
                return RivalIQ.execute('alert:danger', 'Password length must be > 0');
            }

            me.ui.setPasswordBtn.button('loading');

            const deferred = async.callbackToDeferred(function (error) {
                // Refetch the model to reload the version param
                me.model.fetch();

                me.ui.setPasswordBtn.button('reset');

                if (error) {
                    return RivalIQ.execute('alert:error', error);
                }

                RivalIQ.execute('alert:info', `Password set to ${password}`);
            });

            me.model.set({
                newPassword: password
            });
            me.model.setPassword().done(deferred.resolve).fail(deferred.reject);
        },

        delete: function () {
            const me = this;

            RivalIQ.execute('show:modal', new App.views.Delete({
                model: me.model
            }));
        }
    });
}, RivalIQ.utils.async);
